import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import useMediaQuery from '@material-ui/core/useMediaQuery';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
//import Hidden from '@material-ui/core/Hidden';

import Skeleton from '@material-ui/lab/Skeleton';

import TicketIcon from '@material-ui/icons/ConfirmationNumber';

import useApi from 'app/context/useApi';
import Loading from 'app/components/loaders/Loading';

const useStyles = makeStyles(theme => ({
    titleBox: {
        paddingTop: '60px',
        paddingBottom: '60px',
        paddingRight: '20px',
        paddingLeft: '20px',
        textAlign: 'center',
        backgroundImage: 'url("/images/german-club-grey.png")',
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    },
    tabContainer: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    emptyCon: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingRight: '20px',
        paddingLeft: '20px',
        textAlign: 'center'
    },
    paper: {
        padding: theme.spacing(4),
        textAlign: 'center',
        height: '100%'
    },
    avatarContainer: {
        display: 'inline-block'
    }
}));

function GuestTickets(props) {
    const { value, index, tickets, loading, ...other } = props;
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={'ticket-tab-${index}'}
            aria-labelledby={'ticket-tab-${index}'}
            {...other}
            >
            {loading ? (
                <Fragment>
                    <div className="p-t-l"/>
                    <Grid container justify="center" spacing={4}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={classes.paper}>
                                <Skeleton variant="circle" height={40} width={40} className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={10} width="63%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={26} width="40%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="rect" height={66} width="100%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={8} width="40%" className={classes.avatarContainer}/>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={classes.paper}>
                                <Skeleton variant="circle" height={40} width={40} className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={10} width="33%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={26} width="50%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="rect" height={46} width="100%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={8} width="50%" className={classes.avatarContainer}/>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={classes.paper}>
                                <Skeleton variant="circle" height={40} width={40} className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={10} width="63%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={26} width="40%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="rect" height={66} width="100%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={8} width="40%" className={classes.avatarContainer}/>
                            </Paper>
                        </Grid>
                    </Grid>
                </Fragment>
            ) : (
                <Fragment>
                    <div className="p-t-l"/>
                    <Grid container justify="center" spacing={4}>
                        { (tickets.length > 0) && tickets.map((t, index) => (
                            <Grid key={t.id} item xs={12} sm={6} md={4}>
                                <Paper className={classes.paper}>
                                    <div className={classes.avatarContainer}>
                                        <Avatar>
                                            <TicketIcon />
                                        </Avatar>
                                    </div>
                                    <div className="p-t-l"/>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        {t.ticket.event.title}
                                    </Typography>
                                    <Typography variant="h6">{t.ticket.title}</Typography>
                                    <div className="p-t-l"/>
                                    <Typography variant="body2" color="textSecondary">
                                        {t.ticket.description}
                                    </Typography>
                                    <div className="p-t-l"/>
                                    <Typography variant="subtitle2">
                                        {t.ticket.event.event_at_formatted}
                                    </Typography>
                                    <Typography variant="subtitle2" color="primary">
                                        Guest: {t.guest.full_name}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>

                    <div className={classes.emptyCon}>
                        <Typography
                            component="h3"
                            color="textSecondary"
                            variant="h6"
                            gutterBottom
                            >
                            That's all the tickets you have purchased for guests.
                        </Typography>
                        <div className="p-t-l"></div>
                        <Typography
                            component="div"
                            variant="subtitle2"
                            >
                            <Link to="/invitations">
                                View Invitations
                            </Link>
                        </Typography>
                    </div>
                </Fragment>
            )}
        </Typography>
    )
}

function UserTickets(props) {
    const { value, index, tickets, loading, ...other } = props;
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={'ticket-tab-${index}'}
            aria-labelledby={'ticket-tab-${index}'}
            {...other}
            >
            {loading ? (
                <Fragment>
                    <div className="p-t-l"/>
                    <Grid container justify="center" spacing={4}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={classes.paper}>
                                <Skeleton variant="circle" height={40} width={40} className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={10} width="63%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={26} width="40%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="rect" height={66} width="100%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={8} width="40%" className={classes.avatarContainer}/>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={classes.paper}>
                                <Skeleton variant="circle" height={40} width={40} className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={10} width="33%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={26} width="50%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="rect" height={46} width="100%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={8} width="50%" className={classes.avatarContainer}/>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper className={classes.paper}>
                                <Skeleton variant="circle" height={40} width={40} className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={10} width="63%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={26} width="40%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="rect" height={66} width="100%" className={classes.avatarContainer}/>
                                <br/>
                                <Skeleton variant="text" height={8} width="40%" className={classes.avatarContainer}/>
                            </Paper>
                        </Grid>
                    </Grid>
                </Fragment>
            ) : (
                <Fragment>
                    <div className="p-t-l"/>
                    <Grid container justify="center" spacing={4}>
                        { (tickets.length > 0) && tickets.map((t, index) => (

                            <Grid key={t.id} item xs={12} sm={6} md={4}>
                                <Paper className={classes.paper}>
                                    <div className={classes.avatarContainer}>
                                        <Avatar>
                                            <TicketIcon />
                                        </Avatar>
                                    </div>
                                    <div className="p-t-l"/>
                                    <Typography variant="subtitle1" color="textSecondary">
                                        {t.ticket.event.title}
                                    </Typography>
                                    <Typography variant="h6">{t.ticket.title}</Typography>
                                    <div className="p-t-l"/>
                                    <Typography variant="body2" color="textSecondary">
                                        {t.ticket.description}
                                    </Typography>
                                    <div className="p-t-l"/>
                                    <Typography variant="subtitle2">
                                        {t.ticket.event.event_at_formatted}
                                    </Typography>
                                    {(t.guest_id > 0) &&
                                        <Typography variant="subtitle2" color="primary">
                                            Invited By: {t.user.full_name}
                                        </Typography>
                                    }
                                </Paper>
                            </Grid>

                        ))}
                    </Grid>

                    <div className={classes.emptyCon}>
                        <Typography
                            component="h3"
                            color="textSecondary"
                            variant="h6"
                            gutterBottom
                            >
                            That's all the tickets you have purchased.
                        </Typography>
                        <div className="p-t-l"></div>
                        <Typography
                            component="div"
                            variant="subtitle2"
                            >
                            <Link to="/events">
                                View Events
                            </Link>
                        </Typography>
                    </div>
                </Fragment>
            )}
        </Typography>
    )
}

function a11yProps(index) {
  return {
    id: 'ticket-tab-${index}',
    'aria-controls': 'ticket-panel-${index}',
  };
}

export default function Invitations(props) {

    const [ guestTickets, setGuestTickets ] = useState(false);
    const [ userTickets, setUserTickets ] = useState(false);

    const [ activeTab, setActiveTab ] = useState(0);

    const [ loading, setLoading ] = useState(false);

    const { user, stripeKey } = props;

    const classes = useStyles();
    const api = useApi();

    // Getter Functions ------------------------------------------

    const getTickets = () => {

        setLoading(true);

        api.get('/ticket/all')
            .then(res => {
                const newGuestTickets = res.tickets['guest'];
                const newUserTickets = res.tickets['user'];
                setGuestTickets(newGuestTickets);
                setUserTickets(newUserTickets);
            }).catch(error => {
                console.log(error.response);
            }).then(() => {
                setLoading(false);
            });
    }

    const trackPage = () => {
        api.get('/track/tickets');
    }

    useEffect(() => {
        getTickets();
        trackPage();
    }, []);

    // General Functions

    const handleTabs = (event, newTab) => {
        setActiveTab(newTab);
    };

    return (
        <div className={classes.contentContainer}>
            <div className="container app-container">
                <div className={classes.titleBox}>
                    <Typography variant="h4" component="h2">
                        Purchased Tickets
                    </Typography>
                </div>
                <div className={classes.tabContainer}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabs}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        aria-label="Ticket Navigation"
                        >
                        <Tab label="Your Tickets" {...a11yProps(0)}/>
                        <Tab label="Guest Tickets" {...a11yProps(1)}/>
                    </Tabs>
                </div>
                <UserTickets
                    value={activeTab}
                    index={0}
                    tickets={userTickets}
                    loading={loading}
                />
                <GuestTickets
                    value={activeTab}
                    index={1}
                    tickets={guestTickets}
                    loading={loading}
                />
            </div>
        </div>
    )
}
